class campaignRegister {

    static campaign = null;

    static setCampaign(campaign){
        campaignRegister.campaign = campaign;
        try {
            sessionStorage.setItem('campaign', JSON.stringify(campaign));
        }catch (e) {}
    }

    static getCampaign(){
        try {
            if(sessionStorage.getItem('campaign')){
                return JSON.parse(sessionStorage.getItem('campaign'));
            }else{
                return campaignRegister.campaign;
            }
        }catch (e) {
            return campaignRegister.campaign;
        }
    }

    static removeCampaign(){
        campaignRegister.campaign = null;
        try {
            sessionStorage.removeItem('campaign');
        }catch (e) {}
    }

    //SHORTENER
    static set(campaign){
        campaignRegister.setCampaign(campaign);
    }

    static get(){
        return campaignRegister.getCampaign();
    }

    static remove(){
        campaignRegister.removeCampaign();
    }

}

export {campaignRegister}


// WEBPACK FOOTER //
// ./src/services/campaignRegister.js